import React from 'react';
import Logo from '../../assets/Images/logo.png';
import Smile from '../../assets/Images/footer-smile.png';
import {FooterContainer, FooterLinks, FooterLinkTitle, FooterMainRow, PolicyText} from "./footer.styles";
import {Link} from "react-router-dom";

const Footer = ({rootClassName}) => {
    return (
        <FooterContainer className={`rtl ${rootClassName}`}>
            <div className='container'>
                <FooterMainRow className='row pb-4'>
                    <div className='col-auto col-lg-2'/>
                    <div className='col-12 col-lg-2 mb-c-4 mb-lg-0'>
                        <div>
                            <img src={Logo} alt='logo'/>
                        </div>
                    </div>
                    <div className='col-6 col-lg-2'>
                        <div>
                            <FooterLinkTitle>لورم ایپسوم</FooterLinkTitle>
                            <FooterLinks>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                            </FooterLinks>
                        </div>
                    </div>
                    <div className='col-6 col-lg-2'>
                        <div>
                            <FooterLinkTitle>لورم ایپسوم</FooterLinkTitle>
                            <FooterLinks>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                            </FooterLinks>
                        </div>
                    </div>
                    <div className='col-6 col-lg-2 mt-4 mt-lg-0'>
                        <div>
                            <FooterLinkTitle>لورم ایپسوم</FooterLinkTitle>
                            <FooterLinks>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                                <li><Link to='/'>لورم ایپسوم</Link></li>
                            </FooterLinks>
                        </div>
                    </div>
                    <div className='col-6 col-lg-2'>
                        <div className='d-flex align-items-center h-100'>
                            <img src={Smile} alt='smile' className='position-relative'/>
                        </div>
                    </div>
                </FooterMainRow>
                <div className='text-center'>
                    <PolicyText className='mt-1'>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است
                        چاپگرها و متون بلکه</PolicyText>
                </div>
            </div>
        </FooterContainer>
    );
};

export default Footer;
